import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const RilisMusikPreview = () => {
  const highlights = [
    'Distribusi ke 20+ Platform',
    'Royalti 75% untuk Artis',
    'YouTube Content ID Included',
    'Proses 5-7 Hari Kerja',
    'Lifetime & Tanpa Registrasi',
    'Custom Label Mandiri',
  ];

  return (
    <section className="relative py-24 lg:py-28 overflow-hidden bg-[#080808]">
      <div className="absolute top-1/2 -translate-y-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-[#D4A94F]/[0.06] blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
              <Sparkles className="w-3.5 h-3.5 text-[#E9C46A]" />
              <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
                Rilis Musik Gratis
              </span>
            </div>
            <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight mb-5">
              Distribusi Musik{' '}
              <span className="gold-gradient-text">Selamanya GRATIS</span>
            </h2>
            <p className="text-neutral-400 text-lg leading-relaxed mb-8">
              Rilis lagu Anda ke seluruh platform digital worldwide tanpa biaya
              distribusi, tanpa biaya bulanan, tanpa biaya tahunan.
              Royalti 75% untuk artis, hak cipta 100% milik Anda.
            </p>

            <ul className="grid grid-cols-2 gap-3 mb-10">
              {highlights.map((h) => (
                <li key={h} className="flex items-center gap-2.5 text-neutral-300 text-sm">
                  <CheckCircle2 className="w-4 h-4 text-[#E9C46A] flex-shrink-0" />
                  {h}
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap gap-3">
              <Button
                asChild
                className="h-13 px-8 py-3 rounded-full bg-gradient-to-r from-[#E9C46A] to-[#D4A94F] text-black font-semibold btn-transition gold-shimmer hover:shadow-[0_10px_40px_-10px_rgba(212,169,79,0.6)]"
              >
                <Link to="/rilis-musik">
                  Pelajari Selengkapnya <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button
                asChild
                variant="outline"
                className="h-13 px-8 py-3 rounded-full bg-transparent border border-white/15 hover:border-[#D4A94F] hover:bg-[#D4A94F]/5 text-white font-semibold btn-transition"
              >
                <a href="https://www.werdimedia.com/submit-music" target="_blank" rel="noreferrer">
                  Submit Music
                </a>
              </Button>
            </div>
          </div>

          {/* Right pricing card */}
          <div className="relative">
            <div className="relative rounded-3xl border border-[#D4A94F]/30 bg-gradient-to-br from-[#141210] via-[#0d0d0d] to-black p-8 md:p-10 shadow-[0_25px_60px_-15px_rgba(212,169,79,0.25)]">
              <div className="absolute -top-3 left-8 px-3 py-1 rounded-full bg-gradient-to-r from-[#E9C46A] to-[#D4A94F] text-black text-[10px] font-bold uppercase tracking-widest">
                Paket GRATIS
              </div>

              <div className="flex items-baseline gap-2 mb-1 mt-3">
                <span className="text-white font-bold text-6xl gold-gradient-text">Rp 0</span>
                <span className="text-neutral-500 line-through text-sm">Rp 250rb/thn</span>
              </div>
              <p className="text-neutral-500 text-sm mb-8">Sekali submit — live selamanya</p>

              <ul className="space-y-3 mb-8">
                <PriceRow label="Biaya Distribusi" value="GRATIS" highlight />
                <PriceRow label="Hak Cipta" value="100% Artis" />
                <PriceRow label="Royalti" value="75% Artis" />
                <PriceRow label="YouTube Content ID" value="Included" />
                <PriceRow label="ISRC & UPC" value="Gratis" />
                <PriceRow label="Proses Verifikasi" value="5-7 Hari" />
                <PriceRow label="Durasi Live di DSP" value="Lifetime" />
              </ul>

              <Button
                asChild
                className="w-full h-13 py-3 rounded-full bg-gradient-to-r from-[#E9C46A] to-[#D4A94F] text-black font-semibold btn-transition gold-shimmer"
              >
                <Link to="/rilis-musik">
                  Mulai Rilis Sekarang <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const PriceRow = ({ label, value, highlight }) => (
  <li className="flex items-center justify-between py-2 border-b border-white/[0.05]">
    <span className="text-neutral-400 text-sm">{label}</span>
    <span
      className={`font-semibold text-sm ${
        highlight ? 'gold-gradient-text text-base' : 'text-white'
      }`}
    >
      {value}
    </span>
  </li>
);

export default RilisMusikPreview;
